export const urls = {
	get: (id: string) => `/rest/jpo/1.0/permissions/${id}`,
	establish: '/rest/jpo/1.0/permissions/establish',
	revoke: '/rest/jpo/1.0/permissions/revoke',
	getTeamsPermission: (orgId: string) =>
		`/gateway/api/v3/teams/permission/self/organization/${orgId}`,
	getTeamsPermissionV4: (orgId: string, siteId: string) =>
		`/gateway/api/v4/teams/permission/self/organization/${orgId}?siteId=${siteId}`,
} as const;
